<fieldset>
  <div class="is-flex is-align-items-center gap-xs">
    <img
      class="logo"
      src="/dentaire et optique.png"
      alt="icone soins"
      height="48"
      width="48" />
    <h3>{{ 'tarificateur.dental' | translate }}</h3>
  </div>
  <p class="mb-3">{{ 'option.minmedical' | translate }}.</p>
  <mat-radio-group
    [formControl]="fc"
    class="is-flex is-flex-direction-column gap-s">
    <acs-expandable-radio-button
      (expandedChange)="expandPanel(0)"
      [expanded]="expandedOption === 0"
      [canExpand]="false">
      <mat-radio-button
        [value]="options[0].level"
        [disabled]="options[0].disable">
        <span class="is-size-6">{{ options[0].label | translate }}</span>
      </mat-radio-button>
    </acs-expandable-radio-button>
    <acs-expandable-radio-button (expandedChange)="expandPanel(1)" [expanded]="expandedOption === 1">
      <mat-radio-button
        [value]="options[1].level"
        [disabled]="options[1].disable">
        <span class="is-size-6">{{ options[1].label | translate }}</span>
      </mat-radio-button>

      <div details class="option-detail">
        <span class="option-detail-title">{{ 'tarificateur.option.detail_title' | translate }}</span>
        <div class="option-detail-info">
          <span class="option-detail-info-label">{{ 'tarificateur.option.dental_optic.limit_year_beneficiary.title' | translate }}</span>
          <span [innerHTML]=" 'tarificateur.option.dental_optic.limit_year_beneficiary.description.lv1' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.dental_optic.dental_care.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.dental_optic.dental_care.description.lv1' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.dental_optic.orthodontics.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.dental_optic.orthodontics.description.lv1' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.dental_optic.prothesis.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.dental_optic.prothesis.description.lv1' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.dental_optic.glasses_visual_correction.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.dental_optic.glasses_visual_correction.description.lv1' | translate"></span>

          <span class="option-detail-info-link"><a [href]="guaranteesTableLink" target="_blank">{{ 'tarificateur.option.guarantees_table_link' | translate }}</a></span>
        </div>
      </div>
    </acs-expandable-radio-button>
    <acs-expandable-radio-button (expandedChange)="expandPanel(2)" [expanded]="expandedOption === 2">
      <mat-radio-button
        [value]="options[2].level"
        [disabled]="options[2].disable">
        <span class="is-size-6">{{ options[2].label | translate }}</span>
      </mat-radio-button>
      <div details class="option-detail">
        <span class="option-detail-title">{{ 'tarificateur.option.detail_title' | translate }}</span>
        <div class="option-detail-info">
          <span class="option-detail-info-label">{{ 'tarificateur.option.dental_optic.limit_year_beneficiary.title' | translate }}</span>
          <span [innerHTML]=" 'tarificateur.option.dental_optic.limit_year_beneficiary.description.lv2' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.dental_optic.dental_care.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.dental_optic.dental_care.description.lv2' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.dental_optic.orthodontics.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.dental_optic.orthodontics.description.lv2' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.dental_optic.prothesis.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.dental_optic.prothesis.description.lv2' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.dental_optic.glasses_visual_correction.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.dental_optic.glasses_visual_correction.description.lv2' | translate"></span>

          <span class="option-detail-info-link"><a [href]="guaranteesTableLink" target="_blank">{{ 'tarificateur.option.guarantees_table_link' | translate }}</a></span>
        </div>
      </div>
    </acs-expandable-radio-button>
  </mat-radio-group>
</fieldset>
